export default __webpack_public_path__ + "static/media/carbon_user-activity.54571af2.svg";